import * as React from 'react';
import MaskedInput from 'react-text-mask';

import PropTypes from 'prop-types';

import { MASKS, uppercasePipe } from 'utils/masks';

function TextMaskInput({ inputRef, mask, ...rest }) {
  return (
    <MaskedInput
      {...rest}
      ref={ref => inputRef(ref ? ref.inputElement : null)}
      guide={false}
      mask={mask}
    />
  );
}

TextMaskInput.propTypes = {
  inputRef: PropTypes.any,
  mask: PropTypes.any,
};

const MaskedTaxDocumentCPF = props => <TextMaskInput {...props} mask={MASKS.taxDocumentCPF} />;
const MaskedTaxDocumentCNPJ = props => (
  <TextMaskInput {...props} mask={MASKS.taxDocumentCNPJ} pipe={uppercasePipe} />
);
const MaskedTaxDocumentCNPJCPF = props => (
  <TextMaskInput {...props} mask={MASKS.taxDocumentCNPJCPF} pipe={uppercasePipe} />
);
const MaskedNumber = props => <TextMaskInput {...props} mask={MASKS.number} />;
const MaskedPhoneNumber = props => <TextMaskInput {...props} mask={MASKS.phoneNumber} />;
const MaskedFullPhoneNumber = props => <TextMaskInput {...props} mask={MASKS.fullPhoneNumber} />;
const MaskedPostalCode = props => <TextMaskInput {...props} mask={MASKS.postalCode} />;
const MaskedPercentageNumber = props => <TextMaskInput {...props} mask={MASKS.percentageNumber} />;
const MaskedTime = props => <TextMaskInput {...props} mask={MASKS.time} />;
const MaskedNCM = props => <TextMaskInput {...props} mask={MASKS.ncm} />;
const Masked3Digits = props => <TextMaskInput {...props} mask={MASKS.threeDigits} />;
const Masked4Digits = props => <TextMaskInput {...props} mask={MASKS.fourDigits} />;
const Masked6Digits = props => <TextMaskInput {...props} mask={MASKS.sixDigits} />;
const MaskedCurrencyBRL = props => <TextMaskInput {...props} mask={MASKS.currencyBRL} />;
const MaskedSlug = props => <TextMaskInput {...props} mask={MASKS.slug} />;

export {
  MaskedNumber,
  MaskedPercentageNumber,
  MaskedPhoneNumber,
  MaskedFullPhoneNumber,
  MaskedPostalCode,
  MaskedTaxDocumentCNPJ,
  MaskedTaxDocumentCPF,
  MaskedTaxDocumentCNPJCPF,
  MaskedTime,
  MaskedNCM,
  Masked3Digits,
  Masked4Digits,
  Masked6Digits,
  MaskedCurrencyBRL,
  MaskedSlug,
};
